<template>
  <router-link to="." class="back">
    <i class="fas fa-chevron-left fa-xs" /> back
  </router-link>
</template>

<script>
  export default {};
</script>

<style scoped lang="scss">
  @import '~scss/colors';

  a.back {
    display: block;
    color: $red;
    font-size: small;
    font-weight: bold;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/BackButton.vue